
























import {Component, Prop, Vue} from "vue-property-decorator";
import ModalCard from "@/components/Modal/ModalCard.vue";
import ITimeTrackingRecord from "@/models/TimeTracking/ITimeTrackingRecord";
import {Action} from "vuex-class";
import TextArea from "@/components/Form/elements/TextArea.vue";

const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';

const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';


@Component({
  components: {TextArea, ModalCard}
})
export default class NewCommentModal extends Vue {
  public name: string = "NewCommentModal";

  @Action('createComment', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) createComment: any;

  @Prop({required: true})
  public visible!: boolean;

  @Prop({required: true})
  public timeTrackingObject!: ITimeTrackingRecord;

  private commentText: string = '';

  private saveComment(): void {

    this.createComment({resource: RESOURCE_TIME_TRACKING_RECORD, id: this.timeTrackingObject.id, data: this.newCommentData})
    .then((response: any) => {
      this.$emit('on-comment-saved', this.commentText);
      this.commentText = '';
    });



  }

  private get newCommentData(): any {

    return {
      title: '',
      content: this.commentText
    };

  }

  private onVisibleChanged(visible: boolean) {

    this.$emit('visible-changed', visible);

  }

}
